import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type {
  SystemOverviewResponse,
  TokenListResponse,
  TokenQueryParams,
  AttemptListResponse,
  AttemptQueryParams,
  AppStatusResponse,
} from '../types/api';

// Helper to get auth token from localStorage
const getAuthToken = (): string | null => {
  return localStorage.getItem('admin_token');
};

// Build query string from params object
const buildQueryString = (params: TokenQueryParams | AttemptQueryParams): string => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value));
    }
  });
  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};

export const adminApi = createApi({
  reducerPath: 'adminApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/admin',
    prepareHeaders: (headers) => {
      const token = getAuthToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Overview', 'Tokens', 'Attempts', 'AppsStatus'],
  endpoints: (builder) => ({
    // System Overview
    getSystemOverview: builder.query<SystemOverviewResponse, void>({
      query: () => '/system/overview',
      providesTags: ['Overview'],
    }),

    // Push Tokens
    getTokens: builder.query<TokenListResponse, TokenQueryParams>({
      query: (params) => `/push/tokens${buildQueryString(params)}`,
      providesTags: ['Tokens'],
    }),

    // Delivery Attempts
    getAttempts: builder.query<AttemptListResponse, AttemptQueryParams>({
      query: (params) => `/push/attempts${buildQueryString(params)}`,
      providesTags: ['Attempts'],
    }),

    // Apps Status
    getAppsStatus: builder.query<AppStatusResponse, void>({
      query: () => '/apps/status',
      providesTags: ['AppsStatus'],
    }),
  }),
});

export const {
  useGetSystemOverviewQuery,
  useGetTokensQuery,
  useGetAttemptsQuery,
  useGetAppsStatusQuery,
} = adminApi;
